module.exports = __webpack_public_path__ + "img/xhd-banner.5b800f8b.png";